<template>
  <v-card class="elevation-0">
    <div>
      <div class="row-title-btn">
        <div class="controls-actions d-flex justify-end">
          <v-btn @click="openDialog" icon class="ml-2">
            <v-icon size="24">{{ icons.mdiPlus }}</v-icon>
          </v-btn>
        </div>
      </div>
    </div>
    <v-data-table
      :headers="headers"
      :items="managedPublicPlaces"
      :loading="loading"
      item-key="name"
      class="table-rounded datatable-height elevation-3"
      fixed-header
      disable-sort
      hide-default-footer
    >
      <!-- icon -->
      <template #[`item.img_managed_public_places`]="{ item }">
        <div class="img-public-place center-sub-items">
          <img draggable="false" :src="loadImage(item.img_managed_public_places)" :alt="item.name" />
        </div>
      </template>
      <!-- value -->
      <template #[`item.name`]="{ item }">
        <div class="d-flex flex-column">
          <span class="d-block font-weight-semibold text--primary text-truncate text-uppercase">{{ item.name }}</span>
        </div>
      </template>
      <template #[`item.actions`]="{ item }">
        <div class="d-flex">
          <CrudButtons @edit="openEdit(item)" @remove="openRemove(item)"></CrudButtons>
        </div>
      </template>
    </v-data-table>
    <WDialog width="600" :dialog="dialog" :closeDialog="closeDialog" :title="titleDialog" :subtitle="subtitleDialog">
      <template v-slot:form-dialog>
        <FormManagedPublicPlaces
          v-if="dialog"
          :loading="loading"
          :managedPublicPlaceEdited="managedPublicPlaceEdited"
          @beforeUpdate="updateManagedPublicPlace"
          @beforeCreate="createManagedPublicPlace"
        ></FormManagedPublicPlaces>
      </template>
    </WDialog>
  </v-card>
</template>

<script>
import { mdiPlus } from '@mdi/js'
import CrudButtons from '@/components/buttons/CrudButtons.vue'
import FormManagedPublicPlaces from '@/components/forms/FormManagedPublicPlaces.vue'
import useManagedPublicPlace from '@/composables/useManagedPublicPlace'
import WDialog from '@/components/dialogs/WDialog.vue'
import { loadAPIImage } from '@/utils/images'

export default {
  components: {
    CrudButtons,
    WDialog,
    FormManagedPublicPlaces,
  },
  setup() {
    const {
      dialog,
      managedPublicPlaceEdited,
      managedPublicPlaces,
      loading,
      // computed
      titleDialog,
      subtitleDialog,
      // methods
      openDialog,
      openEdit,
      openRemove,
      closeDialog,
      // crud
      createManagedPublicPlace,
      updateManagedPublicPlace,
    } = useManagedPublicPlace()

    const loadImage = src => {
      return loadAPIImage(src)
    }

    return {
      icons: {
        mdiPlus,
      },
      dialog,
      managedPublicPlaceEdited,
      managedPublicPlaces,
      loading,
      // computed
      titleDialog,
      subtitleDialog,
      // methods
      openDialog,
      openEdit,
      openRemove,
      closeDialog,
      loadImage,
      // crud
      createManagedPublicPlace,
      updateManagedPublicPlace,
      headers: [
        { text: 'IMAGEN', value: 'img_managed_public_places' },
        { text: 'NOMBRE', value: 'name' },
        { text: 'CONTENIDO', value: 'description' },
        { text: '', value: 'actions', align: 'right' },
      ],
    }
  },
}
</script>

<style lang="scss" scoped>
.img-public-place {
  padding: 10px;
  margin: 10px;
}

.img-public-place img {
  max-width: 200px;
  max-height: 200px;
}

.center-sub-items {
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>